
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mentors",
      function () {
        return require("private-next-pages/mentors/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mentors"])
      });
    }
  